module.exports = {"pt-BR":{"timeline":{"property-new-rent-card":{"rent":"criou um novo aluguel"}}}}